/**
 * SharePopup
 * @since 1.0.0
 */

export default () => {
  const buttons = document.querySelectorAll('.js-share-popup-button')
  const popup = document.querySelector('.js-share-popup')

  if (!buttons || !popup) return

  const closers = popup.querySelectorAll('.js-close-share-popup')

  ;[...buttons].forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      openPopup(popup)
    })
  })

  ;[...closers].forEach(closer => {
    closer.addEventListener('click', () => {
      closePopup(popup)
    })
  })

  popup.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-share-popup')) { // close if click outside popup container
      closePopup(popup)
    }
  })

}

function openPopup(popup) {
  document.body.classList.add('popup-active') //body
  document.documentElement.classList.add('popup-active') //html
  popup.classList.add('active')
}

function closePopup(popup) {
  document.body.classList.remove('popup-active') //body
  document.documentElement.classList.remove('popup-active') //html
  popup.classList.remove('active')
}


// WEBPACK FOOTER //
// ./src/js/modules/SharePopup.js